import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'search'
})

export class SearchPipe implements PipeTransform {
  transform(items: any[], value : string, fields : string[]): any[] {
    if (!items) return [];
    if (!value || value.length == 0) return items;
    if(fields.length == 4) {
      return items.filter(it => {
        return it[fields[0]] && it[fields[0]].toLowerCase().indexOf(value.toLowerCase()) != -1 ||
          it[fields[1]] && it[fields[1]].toLowerCase().indexOf(value.toLowerCase()) != -1 ||
          it[fields[2]] && it[fields[2]].toLowerCase().indexOf(value.toLowerCase()) != -1||
          it[fields[3]] && it[fields[3]] && it[fields[3]].delegationHabilitationParamsVO
          && it[fields[3]].delegationHabilitationParamsVO.name &&
          it[fields[3]].delegationHabilitationParamsVO.name.toLowerCase().indexOf(value.toLowerCase()) != -1;
      });
    }

    if(fields.length == 3) {
      return items.filter(it => {
        return it[fields[0]] && it[fields[0]].toLowerCase().indexOf(value.toLowerCase()) != -1 ||
          it[fields[1]] && it[fields[1]].toLowerCase().indexOf(value.toLowerCase()) != -1 ||
          it[fields[2]] && it[fields[2]].toLowerCase().indexOf(value.toLowerCase()) != -1;
      });
    }
    if(fields.length == 2) {
      return items.filter(it => {
        return it[fields[0]] && it[fields[0]].toLowerCase().indexOf(value.toLowerCase()) != -1 ||
          it[fields[1]] && it[fields[1]].toLowerCase().indexOf(value.toLowerCase()) != -1;
      });
    }

    return items.filter(it => {
      return it[fields[0]] && it[fields[0]].toLowerCase().indexOf(value.toLowerCase()) != -1;
    });

  }


}



// WEBPACK FOOTER //
// ./src/app/pipe/search.pipe.ts